export default __webpack_public_path__ + "static/media/img-slide-5@2x.cb5beeae.jpeg";